import { FC, HTMLAttributes } from "react";
import { useStyles } from "./RewardView.style";
import { Typography, TypographyVariant, Image } from "@onmo/ui";
import LightEffect from "../../../assets/result/bg_light_effect_1x.webp";
import LightEffect2x from "../../../assets/result/bg_light_effect_2x.webp";
import LightEffect3x from "../../../assets/result/bg_light_effect_3x.webp";
import Gem from "../../../assets/icons/gem_1x.webp";
import Gem2x from "../../../assets/icons/gem_2x.webp";
import Gem3x from "../../../assets/icons/gem_3x.webp";
import { Confetti } from "../Confetti/Confetti";
import { GemAnimation } from "../GemAnimation/GemAnimation";
import { useTranslation } from "react-i18next";

interface IRewardView extends HTMLAttributes<HTMLDivElement> {
  gems: number;
}

export const RewardView: FC<IRewardView> = (props) => {
  const { gems } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.rewardView}>
      <GemAnimation gems={gems} />
      <Confetti />
      <Typography
        className={classes.title}
        variant={TypographyVariant.HeadingH4Bold}
      >
        {t("rewards")}
      </Typography>
      <div className={classes.result}>
        <Image
          src={LightEffect}
          src2x={LightEffect2x}
          src3x={LightEffect3x}
          className={classes.img}
        />
        <div className={classes.gemContent}>
          <Image
            src={Gem}
            src2x={Gem2x}
            src3x={Gem3x}
            className={classes.gemIcon}
          />
          <Typography className={classes.gem}>{gems}</Typography>
        </div>
      </div>
    </div>
  );
};

export default RewardView;
